export default __webpack_public_path__ + "static/media/home-marketing-agency-img-01.7817b5d2.png";